import { useQuery } from '@tanstack/react-query'

import { queries } from '~/features/partners/utils'

const useGetPartnerConfigByOrgId = (orgId: string) => {
  return useQuery(queries.partnerByOrgId(orgId))
}

export default useGetPartnerConfigByOrgId
